import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { getDateFormatted } from '../../helpers/DateTime';
import { getSetting } from '../../helpers/Settings';

const FileExpirationIcon = ({ file }) => {
  const intl = useIntl();

  if (!file.expires_at || !getSetting('expiration_date')) {
    return null;
  }

  return (
    <span className={classnames('file-expiration-icon', { 'file-expired': file.expired })}>
      <i className="fa-solid fa-timer" id={`FileExpiredTooltip-${file.uuid}`} />
      <UncontrolledTooltip fade={false} placement="bottom" target={`FileExpiredTooltip-${file.uuid}`}>
        {intl.formatMessage({
          defaultMessage: '{status, select, true {Expired} other {Expires}} on {date}',
        }, {
          status: file.expired,
          date: getDateFormatted(file.expires_at),
        })}
      </UncontrolledTooltip>
    </span>
  );
};

FileExpirationIcon.propTypes = {
  file: PropTypes.object.isRequired,
};

export default FileExpirationIcon;
